import { render, staticRenderFns } from "./EmploymentDetailsForm.vue?vue&type=template&id=3378f912&"
import script from "./EmploymentDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./EmploymentDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports